<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <PrintViewBar v-if="Subscription" :showEmailBtn="showEmailBtn" :id="Subscription.id" type="invoice"
          :title="`Subscription # ${this.Subscription.id}`" :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name" :email="printEmail" :obj="Subscription.Donor"
          :text="`${currentBusiness.name} Subscription click here to view`" />

        <v-container fluid>
          <v-card-text class="pb-0">
            <div v-if="!$vuetify.breakpoint.xsOnly">
              <img class="paidImg" v-if="Subscription.deletedAt" width="300"
                src="../../../assets/deletedStamp-removebg-preview.png" />
            </div>

            <v-layout row>
              <v-flex class="text-left text-capitalize">
                <div class=" headline font-weight-bold">
                  {{ currentBusiness.name }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase">{{ currentBusiness.state }}
                  </span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.email }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.website }}
                </div>

                <div :class="{ 'display-3': !$vuetify.breakpoint.xsOnly }"
                  class="mt-2 text-h5 font-weight-black blue--text">
                  SUBSCRIPTION
                </div>
                <div class="font-weight-regular">
                  <div class="font-weight-medium">BILL TO</div>
                  <div class="font-weight-bold">
                    <span v-if="Subscription.Donor">{{ Subscription.Donor.name }}</span>
                    <span v-if="Subscription.Customer">{{ Subscription.Customer.name }}</span>
                  </div>
                  <div>
                    <span v-if="Subscription.Donor">{{ Subscription.Donor.address }}</span>
                    <span v-if="Subscription.Customer">{{ Subscription.Customer.address }}</span>
                  </div>
                  <div v-if="Subscription.Donor && Subscription.Donor.city">
                    {{ Subscription.Donor.city }},<span class="text-uppercase">{{ Subscription.Donor.state }}
                    </span>
                    {{ Subscription.Donor.zip }}
                  </div>
                  <div v-if="Subscription.Customer && Subscription.Customer.city">
                    {{ Subscription.Customer.city }},<span class="text-uppercase">{{ Subscription.Customer.state }}
                    </span>
                    {{ Subscription.Customer.zip }}
                  </div>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-right">
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img v-if="currentBusiness.imageUrl" height="120" class="logo mb-3" :src="currentBusiness.imageUrl"
                    alt="" />
                </div>
                <div v-if="!$vuetify.breakpoint.xsOnly" class="barcode mt-2">
                  *{{ Subscription.id }}*
                </div>
                <div class="font-weight-regular">
                  <v-row>
                    <v-col class="pb-0">SUBSCRIPTION #</v-col>
                    <v-col class="pb-0">{{ Subscription.id }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">STARTING DATE: </v-col>
                    <v-col class="py-0">{{ Subscription.startingDate | moment("MM/DD/YYYY") }}</v-col>
                  </v-row>
                  <v-row v-if="!Subscription.recurringForever">
                    <v-col class="py-0">ENDING DATE: </v-col>
                    <v-col class="py-0">{{ Subscription.endDate | moment("MM/DD/YYYY") }}</v-col>
                  </v-row>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pb-0" v-if="Subscription.Donor && Subscription.Donor.showBalance">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="headline font-weight-medium text-right blue--text">
                  BALANCE
                </div>
                <div class="display-2 font-weight-light text-right">
                  {{ Subscription.Donor.balance | currency }}
                </div>
                <br />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pb-0" v-if="Subscription.Customer && Subscription.Customer.showBalance">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="headline font-weight-medium text-right blue--text">
                  BALANCE
                </div>
                <div class="display-2 font-weight-light text-right">
                  {{ Subscription.Customer.balance | currency }}
                </div>
                <br />
              </v-flex>
            </v-layout>
          </v-card-text>
          <div>
            <v-layout v-if="Subscription.studentSub">
              <v-flex>
                <div class="text-center">BASED ON STUDENT COUNT</div>
              </v-flex>
            </v-layout>
            <v-data-table class="mt-10" v-if="Subscription.studentSub" dense :headers="headers" sort-by="name"
              :itemsPerPage="Subscription.Students.length" hide-default-footer :items="Subscription.Students">
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left">1x 
                    <span class="font-weight-bold" v-if="item.fullName"> {{ item.fullName }}</span>
                    <div class="ml-5" v-for="(row, idx) in item.ClassStudents" :key="idx">
                      <div>-{{ row.Class.name }}</div>
                    </div>
                  
                  </td>
                  <td class="text-right">
                    {{ getTotalParentPay(item.ClassStudents) | currency }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-data-table class="mt-10" v-else dense :headers="headers" sort-by="name"
              :itemsPerPage="Subscription.SubscriptionDetails.length" hide-default-footer
              :items="Subscription.SubscriptionDetails">
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left">{{ item.qty }}x {{ item.name }} <span class="font-weight-bold"
                      v-if="item.Student && item.Student.fullName">({{ item.Student.fullName }})</span></td>
                  <td class="text-right">
                    {{ (item.price * item.qty) | currency }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>

          <v-card-text>
            <v-row>
              <v-col sm="12" md="4" offset-md="8">
                <v-layout>
                  <v-flex>
                    <div class="text-center">NEXT INVOICE DATE - {{ Subscription.nextInvoiceDate | moment("MM/DD/YYYY")
                      }}</div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">TOTAL:</div>
                  </v-flex>
                  <v-flex>
                    <div v-if="Subscription.studentSub" class="font-weight-medium text-right">
                      {{ totalStudents() | currency }}
                    </div>
                    <div v-else class="font-weight-medium text-right">
                      {{ Subscription.total | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <!-- <div v-if="Subscription.Donor && currentBusiness.metadata.taxExam" class="font-weight-medium text-center mt-5">
              {{ currentBusiness.metadata.taxExam }}
            </div>
            <div v-if="Subscription.Customer && currentBusiness.policy" class="font-weight-medium mt-3">
              POLICY
            </div>
            <v-divider v-if="Subscription.Customer && currentBusiness.policy"></v-divider>
            <div v-if="Subscription.Customer" style="line-height: 12px;">
              <small>{{ currentBusiness.policy }}</small>
            </div> -->
            <v-col class="mt-4" align="right">
              Power By: <span>taleem.app</span>
            </v-col>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";

import subscriptionService from "../service";
import Hashids from "hashids";
import { mapGetters, mapActions } from "vuex";
const hashids = new Hashids();

export default {
  data() {
    return {
      showEmailBtn: true,
      isLoading: true,
      Subscription: {
        SubscriptionDetails: [],
      },
      headers: [
        {
          text: "ITEM NAME",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        {
          text: "TOTAL",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    printEmail() {
      let email = null
      if (this.Subscription.Donor && this.Subscription.Donor.email) {
        email = this.Subscription.Donor.email
      }
      if (this.Subscription.Donor && this.Subscription.Donor.email) {
        email = this.Subscription.Donor.email
      }

      return email
    }
  },
  created() {
    if (this.$route.meta.public) {
      this.loadPublicData();
    } else {
      this.loadData();
      if (!this.currentBusiness) this.initUser();
    }
  },
  components: { PrintViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    getTotalParentPay(obj) {
      let total = 0
      // console.log('obj', obj)   
      obj.map(row => {
        // console.log('row', row)
        total += row.parentPay
      })
      return total
    },
    totalStudents() {
      // console.log('sub', this.Subscription)
      let total = 0
      this.Subscription.Students.map(student => {
        student.ClassStudents.map(row => {
          total += row.parentPay
        })
      })

      return total 
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      return subscriptionService
        .publicGetById(id, { invoice: true, key: key, includeBusiness: true })
        .then((response) => {
          console.log("response invoice", response);
          this.initBusiness(response.data.Business);
          this.$Progress.finish();
          this.Subscription = response.data;
          document.title = `${this.currentBusiness.name} - Subscription # ${this.Subscription.id}`;
          if (this.Subscription.SubscriptionDetails.length) {
            let total = 0
            this.Subscription.SubscriptionDetails.map(detail => {
              total += (detail.total * detail.qty)
            })
            this.Subscription.total = total
          }
          this.isLoading = false;
        });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      return subscriptionService.getById(id, { invoice: true }).then((response) => {
        console.log("response", response);
        this.Subscription = response.data;
        if (this.Subscription.Donor && this.Subscription.Donor.email) {
          this.showEmailBtn = true;
        }
        if (this.Subscription.SubscriptionDetails) {
          let total = 0
          this.Subscription.SubscriptionDetails.map(detail => {
            total += (detail.price * detail.qty)
          })
          this.Subscription.total = total
        }
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
